function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
module.exports = _forceReduced;


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/ramda/src/internal/_forceReduced.js
// module id = 1861
// module chunks = 0